import axios from 'axios'
import { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Modal, Row, Table } from 'react-bootstrap'
import Loader from '../components/Loader'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { checkError, getCookie, isObjectEmpty } from '../utils/utils'
import { useOutletContext } from 'react-router-dom'
import { Checkbox } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { paramsSerializer } from "../utils/utils";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import EditIcon from '@mui/icons-material/Edit';
import { user, api } from '../services/config'


const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60px',
    height: '100%',
}));

const lightTheme = createTheme({ palette: { mode: 'light' } });


function AccountScreen() {
    const { getRole, profileState, setProfileState } = useOutletContext();
    const { profile } = profileState
    const [projectList, setProjectList] = useState([])
    const [loading, setLoading] = useState(false)
    const [projectDetails, setProjectDetails] = useState()

    const [validatedAddProject, setValidatedAddProject] = useState(false);
    const [validatedAddPerm, setValidatedAddPerm] = useState(false);
    const [validatedUpdateProject, setValidatedUpdateProject] = useState(false);

    const [checkedPerm, setCheckedPerm] = useState(false)

    const [projectLabel, setProjectLabel] = useState()
    const [dblind, setDblind] = useState(false)
    const [projectLabelAdd, setProjectLabelAdd] = useState()
    const [dblindAdd, setDblindAdd] = useState(false)
    const csrftoken = getCookie('csrftoken');

    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const [addPermIsOpen, setAddPermIsOpen] = useState(false)

    const [addProjectIsOpen, setaddProjectIsOpen] = useState(false)

    const [query, setQuery] = useState()
    const [usernameQuery, setUsernameQuery] = useState()
    const [profiles, setProfiles] = useState([])
    const [selectedProfile, setSelectedProfile] = useState()
    const [loadingProfile, setLoadingProfile] = useState(false)
    const [role, setRole] = useState()
    const [isAdmin, setIsAdmin] = useState(false)
    const [refresh, setRefresh] = useState(false)


    const [updatePermIsOpen, setUpdatePermIsOpen] = useState(false)

    const [permId, setPermId] = useState()
    const [permProfile, setPermProfile] = useState()
    const [permOrcid, setpermOrcid] = useState()
    const [permUsername, setPermUsername] = useState()

    const [deleteProjectModalOpen, setDeleteProjectModalOpen] = useState(false);
    const [projectToDelete, setProjectToDelete] = useState(null);
    const [deleteConfirmationInput, setDeleteConfirmationInput] = useState("");

    useEffect(() => {
        setLoading(true)
        async function fetchProjects() {
            await axios.get(`${api.project}list/`)
                .then(res => {
                    setProjectList(res.data.projects)
                    setLoading(false)
                })
                .catch(
                    function (error) {
                        setLoading(false)
                        return Promise.reject(error)
                    }
                )
        }
        fetchProjects()
    }, [refresh])

    useEffect(() => {
        async function fetchIsAdmin() {
            await axios.get(user.profile)
                .then(res => {
                    if (res.status === 200 && res.data.admin)
                        setIsAdmin(true)
                })
                .catch(
                    function (error) {
                        return Promise.reject(error)
                    }
                )
        }
        fetchIsAdmin()
    }, [])

    useEffect(() => {
        async function fetchProfiles() {
            let data = {
                'orcid': query ? query : null,
                'username': usernameQuery ? usernameQuery : null,
            };
            await axios.get(`${api.project}${projectDetails.id}/profiles/`, {
                data,
                paramsSerializer,
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                }
            })
                .then(res => {
                    setProfiles(res.data)
                    setLoadingProfile(true)
                })
                .catch(
                    function (error) {
                        setLoadingProfile(true)
                        return Promise.reject(error)
                    }
                )
        }
        setLoadingProfile(false)
        if (query !== undefined || usernameQuery !== undefined) fetchProfiles()
    }, [csrftoken, projectDetails, query, usernameQuery])

    const handleInputChange = query => {
        setProfiles([])
        setQuery(query);
        setUsernameQuery(null)
    };

    const handleUsernameInputChange = query => {
        setProfiles([])
        setQuery(null);
        setUsernameQuery(query)
    };


    async function onClickButton(id, projectName) {
        await getRole(id, projectName)
    }

    async function showProject(id) {
        const { data } = await axios.get(`${api.project}${id}/`)
        setProjectDetails(data)
        setProjectLabel(data.label)
        setDblind(data.dblind)
    }
    const onShowSuccessAddPermMessage = () => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
            setAddPermIsOpen(false)
            setRole()
            setSelectedProfile()
            setValidatedAddPerm(false)
            setCheckedPerm(false)
            setUpdatePermIsOpen(false)
        }, 500)
    };

    const onShowSuccessMessage = () => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
            setaddProjectIsOpen(false)
        }, 500)
    };

    const onShowErrorMessage = () => {
        setShowError(true)
        window.setTimeout(() => {
            setShowError(false)
        }, 2000)
    };

    async function onClickUpdateButton() {
        if (projectLabel !== undefined && projectLabel !== "") {
            axios.put(`${api.project}${projectDetails.id}/`, {
                label: projectLabel,
                dblind: dblind,
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
            })
                .then(checkError)
                .then(() => {
                    onShowSuccessMessage();
                    setRefresh(!refresh)
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }
        setValidatedUpdateProject(true);
    }

    async function onClickAddButton(e) {
        e.preventDefault()
        if (projectLabelAdd !== undefined && projectLabelAdd !== "") {
            axios.post(`${api.project}add/`, {
                label: projectLabelAdd,
                dblind: dblindAdd,
                permissions: []
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
            })
                .then(checkError)
                .then((data) => {
                    onShowSuccessMessage();
                    setRefresh(refresh => !refresh)
                    setValidatedAddProject(false)
                    setProjectLabelAdd()
                    setDblind()

                    const role = isAdmin ? 3 : 2;
                    const projectRole = { projectId: data.id, projectName: data.label, role: role };
                    setProfileState((state) => ({ ...state, projectRole }));
                    localStorage.setItem('projectRole', JSON.stringify(projectRole))
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }
        setValidatedAddProject(true);
    }



    const handleEditPerm = (id, profile, orcid, role, username) => {
        setUpdatePermIsOpen(true)
        setAddPermIsOpen(true)
        setPermId(id)
        setPermProfile(profile)
        setpermOrcid(orcid)
        setRole(role)
        setPermUsername(username)
    }


    function onAddperm() {
        setAddPermIsOpen(addPermIsOpen => !addPermIsOpen)
    }

    function formHandleAddPerm(e) {
        e.preventDefault()
        setCheckedPerm(true);
        if (selectedProfile !== undefined && !isObjectEmpty(selectedProfile[0]) && role !== undefined && role !== null) {
            setValidatedAddPerm(true);
            setCheckedPerm(false);
            axios.post(`${api.project}${projectDetails.id}/perms/`, {
                id: selectedProfile[0].id,
                username: selectedProfile[0].username,
                orcid: selectedProfile[0].orcid,
                role: role
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
            })
                .then(checkError)
                .then(() => {
                    onShowSuccessAddPermMessage();
                    showProject(projectDetails.id)
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }


    }

    function formHandleUpdatePerm(e) {
        e.preventDefault()
        setCheckedPerm(true);
        if (role !== undefined && role !== null && role !== 0) {
            setValidatedAddPerm(true);
            setCheckedPerm(false);
            axios.put(`${api.project}${projectDetails.id}/perms/${permId}/`, {
                id: permProfile,
                orcid: permOrcid,
                project: projectDetails.id,
                role
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
            })
                .then(checkError)
                .then(() => {
                    onShowSuccessAddPermMessage();
                    showProject(projectDetails.id)
                    setRole()
                    setPermId()
                    setpermOrcid()
                    setPermProfile()
                    setPermUsername()
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }
    }

    async function onDeleteProject(id) {
        await axios.delete(`${api.project}${id}/`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken
            },
        });
        setRefresh(refresh => !refresh)
        if (projectDetails && (id === projectDetails.id))
            setProjectDetails()

    }


    async function onDeletePerm(id) {
        await axios.delete(`${api.project}${projectDetails.id}/perms/${id}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken
            },
        });
        showProject(projectDetails.id)
    }

    const openDeleteModal = (project) => {
        setProjectToDelete(project);
        setDeleteProjectModalOpen(true);
        setDeleteConfirmationInput("");
    };

    const closeDeleteModal = () => {
        setDeleteProjectModalOpen(false);
        setProjectToDelete(null);
        setDeleteConfirmationInput("");
    };

    const handleConfirmDelete = async () => {
        if (projectToDelete && deleteConfirmationInput === projectToDelete.label) {
            await onDeleteProject(projectToDelete.id);

            if (profileState.projectRole?.projectId === projectToDelete.id) {
                setProfileState(prevState => {
                    const newState = { ...prevState };
                    delete newState.projectRole;
                    return newState;
                });
                localStorage.removeItem('projectRole');
            }

            closeDeleteModal();
        }
    };


    return (
        <div className="container-element ml-5">
            {deleteProjectModalOpen && <Modal show={deleteProjectModalOpen} onHide={closeDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Supprimer le projet</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Êtes-vous sûr de vouloir supprimer le projet <strong>{projectToDelete?.label}</strong> ?</p>
                    <p>Cette action est irréversible.</p>
                    <Form.Group>
                        <Form.Label>Veuillez saisir le nom du projet pour confirmer :</Form.Label>
                        <Form.Control
                            type="text"
                            value={deleteConfirmationInput}
                            onChange={(e) => setDeleteConfirmationInput(e.target.value)}
                            placeholder={projectToDelete?.label}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={closeDeleteModal}>Annuler</Button>
                    <Button
                        variant="danger"
                        onClick={handleConfirmDelete}
                        disabled={deleteConfirmationInput !== projectToDelete?.label}
                    >
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>}
            {addPermIsOpen && <Modal
                show={addPermIsOpen}
                onHide={() => {
                    setAddPermIsOpen(addPermIsOpen => !addPermIsOpen)
                    setRole()
                    setPermId()
                    setpermOrcid()
                    setPermProfile()
                    setPermUsername()
                    setUpdatePermIsOpen(false)
                    setCheckedPerm(false)
                }}
                aria-labelledby="modal-sizes-title-md-1"
                dialogClassName="w-90"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Alert className="mx-5" variant="success" show={showSuccess} >
                        {
                            updatePermIsOpen ? "Permission modifié avec succès" : "Permission ajouté avec succès"
                        }

                    </Alert>
                    <Alert className="mx-5" variant="danger" show={showError} >
                        {
                            updatePermIsOpen ? "Une erreur s'est produite lors de la modification de permission" : "Une erreur s'est produite lors de la création de permission"
                        }

                    </Alert>
                    <Form className="mt-3 mx-5" noValidate validated={validatedAddPerm} >
                        <Form.Group as={Row} className="mb-3" controlId="">
                            <Form.Label column sm="6" xs="12">
                                ORCID <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Col sm="6" xs="12">
                                {
                                    updatePermIsOpen
                                        ? <Form.Control defaultValue={permOrcid} disabled />
                                        : <>
                                            <Typeahead
                                                className={checkedPerm && !selectedProfile?.[0] ? "is-invalid" : ""}
                                                isInvalid={checkedPerm && !selectedProfile?.[0]}
                                                selected={selectedProfile ? selectedProfile : []}
                                                id="search-profile"
                                                onChange={setSelectedProfile}
                                                labelKey="orcid"
                                                emptyLabel={!(query !== undefined && query !== null && query.length !== 0) ? "Commencer à saisir..." : !loadingProfile ? "Recherche..." : "Aucune correspondance trouvée"}
                                                options={(query !== undefined && query !== null && query.length !== 0) ? profiles : []}
                                                onInputChange={handleInputChange}
                                                placeholder="Sélectionnez un profil..."
                                                style={{ flex: 1 }}
                                            />
                                            <Form.Control.Feedback type="invalid">{(query && query.length > 0) ? "Veuillez renseigner une valeur existante." : "Veuillez renseigner ce champ."}</Form.Control.Feedback>
                                        </>
                                }
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="">
                            <Form.Label column sm="6" xs="12">
                                Nom d'utilisateur : <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Col sm="6" xs="12">
                                {
                                    updatePermIsOpen
                                        ? <Form.Control defaultValue={permUsername} disabled />
                                        : <>
                                            <Typeahead
                                                className={checkedPerm && !selectedProfile?.[0] ? "is-invalid" : ""}
                                                isInvalid={checkedPerm && !selectedProfile?.[0]}
                                                selected={selectedProfile ? selectedProfile : []}
                                                id="basic-profile-by-username"
                                                onChange={setSelectedProfile}
                                                labelKey="username"
                                                emptyLabel={!(usernameQuery !== undefined && usernameQuery !== null && usernameQuery.length !== 0) ? "Commencer à saisir..." : !loadingProfile ? "Recherche..." : "Aucune correspondance trouvée"}
                                                options={(usernameQuery !== undefined && usernameQuery !== null && usernameQuery.length !== 0) ? profiles : []}
                                                onInputChange={handleUsernameInputChange}
                                                placeholder="Sélectionnez un profil ..."
                                                style={{ flex: 1 }}
                                            />
                                            <Form.Control.Feedback type="invalid">{(usernameQuery && usernameQuery.length > 0) ? "Veuillez renseigner une valeur existante." : "Veuillez renseigner ce champ."}</Form.Control.Feedback>
                                        </>
                                }

                            </Col>
                        </Form.Group>
                        <Form.Group>
                            <div className="text-center mb-3">
                                <Form.Control
                                    className={checkedPerm && (role == null) ? "is-invalid" : ""}
                                    isInvalid={checkedPerm && (role == null)}
                                    required
                                    as="select"
                                    size="sm"
                                    aria-label="select role"
                                    value={role}
                                    onChange={(e) => {
                                        if (e.target.value !== "0")
                                            setRole(e.target.value);
                                        else setRole()
                                    }}
                                >
                                    <option value={0}>Role... *</option>
                                    <option value={"GUEST"}>Visiteur</option>
                                    <option value={"EDITO"}>Editeur</option>
                                    <option value={"CHIEF"}>Chef de projet</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez renseigner ce champ.
                                </Form.Control.Feedback>
                            </div>
                        </Form.Group>

                        <div className="text-center">
                            {
                                updatePermIsOpen ? <Button type="submit" onClick={formHandleUpdatePerm}>Modifier</Button> : <Button type="submit" onClick={formHandleAddPerm}>Ajouter</Button>
                            }
                        </div>

                    </Form>
                </Modal.Body>
            </Modal>}
            {addProjectIsOpen && <Modal
                show={addProjectIsOpen}
                onHide={() => setaddProjectIsOpen(addProjectIsOpen => !addProjectIsOpen)}
                aria-labelledby="modal-sizes-title-md-3"
                dialogClassName="w-90"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Alert className="mx-5" variant="success" show={showSuccess} >
                        Projet ajouté avec succès
                    </Alert>
                    <Alert className="mx-5" variant="danger" show={showError} >
                        Une erreur s'est produite lors de la création du projet
                    </Alert>
                    <Form className="mt-3 mx-5" noValidate validated={validatedAddProject} >
                        <Form.Group as={Row} className="mb-3" controlId="">
                            <Form.Label column sm="6" xs="12">
                                Libellé du projet: <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Col sm="6" xs="12">
                                <Form.Control required defaultValue={projectLabelAdd} onChange={(e) => (setProjectLabelAdd(e.target.value))} />
                                <Form.Control.Feedback type="invalid">
                                    Veuillez renseigner ce champ.
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="">
                            <Form.Label column sm="6" xs="12">
                                Double aveugle:
                            </Form.Label>
                            <Col sm="6" xs="12">
                                <Checkbox
                                    checked={dblindAdd}
                                    onChange={() => setDblindAdd(dblindAdd => !dblindAdd)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    color="default"

                                />
                                <Form.Control.Feedback type="invalid">
                                    Veuillez renseigner ce champ.
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <div className='text-center mt-2'>
                            <Button type="submit" onClick={onClickAddButton}>Ajouter le projet</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>}
            <Row>
                <Col xl={2} lg={4}>
                    <h3>Mon profil</h3>
                    <Row><Col>Nom d'utilisateur:</Col><Col>{profile.username}</Col> </Row>
                    <Row>
                        <Col>Nom:</Col>
                        <Col>{profile.last_name}</Col>
                    </Row>
                    <Row>
                        <Col>Prénom:</Col>
                        <Col>{profile.first_name}</Col>
                    </Row>
                    <Row>
                        <Col>
                            <a href={`https://orcid.org/${profile.orcid}`} className="d-flex align-items-center">
                                <img
                                    className="mr-1"
                                    alt="ORCID logo"
                                    src="https://info.orcid.org/wp-content/uploads/2019/11/orcid_16x16.png"
                                    width="16"
                                    height="16"
                                />
                                {profile.orcid}
                            </a>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col>Biography:</Col>
                        <Col>{profile.biography}</Col>
                    </Row> */}
                </Col>
                <Col xl={4} lg={7}>
                    <h3>Mes projets :</h3>
                    {loading && <Loader />}
                    <Grid item>
                        <ThemeProvider theme={lightTheme}>
                            <Box
                                sx={{
                                    p: 2,
                                    width: 500,
                                    bgcolor: 'background.default',
                                    display: 'grid',
                                    gap: 4,
                                }}
                            >
                                {(projectList.length !== 0) && projectList.map((item) =>
                                    <div key={item.id} className="d-flex align-items-stretch">
                                        <Item style={{ cursor: "pointer", width: "100%" }} onClick={() => onClickButton(item.id, item.label)} elevation={3}>
                                            {item.label}
                                        </Item>
                                        <div className='ml-2 d-flex flex-column'>
                                            {(item.permission >= 2) &&
                                                <Button variant="info" className='mb-1 w-100' onClick={() => showProject(item.id)}>Administrer</Button>
                                            }
                                            {(isAdmin) &&
                                                <Button variant='danger' className='w-100' onClick={() => openDeleteModal(item)}>Supprimer</Button>
                                            }
                                        </div>
                                    </div>
                                )}

                                {(isAdmin) &&
                                    <div className='text-center mt-2'>
                                        <Button onClick={() => setaddProjectIsOpen(true)}>Ajouter un projet</Button>
                                    </div>
                                }
                            </Box>
                        </ThemeProvider>
                    </Grid>
                </Col>

                <Col className='ml-5' xl={5} lg={8}>
                    {
                        !!projectDetails && <div>
                            <h3>Paramétrage du projet :</h3>
                            <Alert className="mx-5" variant="success" show={showSuccess} >
                                Projet modifié avec succès
                            </Alert>
                            <Alert className="mx-5" variant="danger" show={showError} >
                                Une erreur s'est produite lors de la modification de projet
                            </Alert>
                            <Form className="mt-3" noValidate validated={validatedUpdateProject} >
                                <Form.Group as={Row} className="mb-3" controlId="">
                                    <Form.Label column sm="6" xs="12">
                                        Libellé du projet: <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <Col sm="6" xs="12">
                                        <Form.Control required value={projectLabel} onChange={(e) => (setProjectLabel(e.target.value))} />
                                        <Form.Control.Feedback type="invalid">
                                            Veuillez renseigner ce champ.
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="">
                                    <Form.Label column sm="6" xs="12">
                                        Double aveugle:
                                    </Form.Label>
                                    <Col sm="6" xs="12">
                                        <Checkbox
                                            checked={dblind}
                                            onChange={() => setDblind(dblind => !dblind)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            color="default"
                                        // size="small"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Veuillez renseigner ce champ.
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <div className='text-center mt-1'>
                                    <Button onClick={onClickUpdateButton}>Modifier le projet</Button>
                                </div>
                                <div className='mb-1 mt-2'>
                                    Permissions :
                                </div>

                                <Table striped bordered hover responsive className='table-sm'>
                                    <thead>
                                        <tr>
                                            <th>Nom d'utilisateur</th>
                                            <th>ORCID</th>
                                            <th>Role</th>
                                            <th style={{ width: "17%" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projectDetails.permissions.map(perm => (
                                            <tr key={perm.id}>
                                                <td>{perm.username}</td>

                                                <td>{perm.orcid}</td>
                                                <td>
                                                    {(perm.role === "GUEST") && "Visiteur"}
                                                    {(perm.role === "EDITO") && "Editeur"}
                                                    {(perm.role === "CHIEF") && "Chef de projet"}
                                                </td>
                                                <td>
                                                    <Button size="sm" variant='danger' onClick={() => onDeletePerm(perm.id)}><DeleteIcon /></Button>
                                                    <Button size="sm" className="ml-1" variant='warning' onClick={() => handleEditPerm(perm.id, perm.profile, perm.orcid, perm.role, perm.username)}><EditIcon /></Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <div className='text-center mt-1'>
                                    <Button onClick={onAddperm}>Ajouter une permission</Button>
                                </div>
                            </Form>

                        </div>
                    }
                </Col>


            </Row>
        </div>
    )
}

export default AccountScreen
